export { default } from "./useAdminConsoleAddFacultyPost";
